<template>
  <div>
    <div class="mb-3">
      <v-layout>
        <v-flex class="pa-2" @click="ptype = 'paypal'">
          <div
            class="text-xs-center pa-2"
            style="border: 2px solid #eee; border-radius: 10px; cursor: pointer"
            :style="{ 'border-color': ptype == 'paypal' ? '#4caf50' : '#eee' }"
          >
            <img :src="'/static/img/assets/zpayment/paypal.svg'" style="width: 30px" />
            <div>PayPal</div>
            <v-icon :color="ptype == 'paypal' ? 'success' : 'grey lighten-3'">check_circle</v-icon>
          </div>
        </v-flex>
        <v-flex class="caption grey--text shrink">
          <v-layout justify-center align-center row style="height: 100%">
            <span>{{ $t('or') }}</span>
          </v-layout>
        </v-flex>
        <v-flex class="pa-2" @click="ptype = 'transfer'">
          <div
            class="text-xs-center pa-2"
            style="border: 2px solid #eee; border-radius: 10px; cursor: pointer"
            :style="{ 'border-color': ptype == 'transfer' ? '#4caf50' : '#eee' }"
          >
            <img :src="'/static/img/assets/zpayment/cash.svg'" style="width: 30px" />
            <div>{{ $t('Premium Transfer') }}</div>
            <v-icon :color="ptype == 'transfer' ? 'success' : 'grey lighten-3'"
              >check_circle</v-icon
            >
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div>
      <div class="primary--text">{{ $t('Description') }}</div>
      <v-layout class="pa-2" v-if="params != 'btn_presets_fb'">
        <v-flex>
          {{ $t('premium') }}
          <template v-if="zwiz_package.months == 12">1 {{ $t('year') }}</template>
          <template v-else>{{ zwiz_package.months }} {{ $t('months') }}</template>
          x 1
          <span>
            (
            <template v-if="zwiz_package.months == 12">365</template>
            <template v-else>{{ zwiz_package.months * 30 }}</template>
            {{ $t('Days') }} )
          </span>
        </v-flex>
        <v-flex class="text-xs-right"
          >{{ zwiz_package.discount | numberFormat }} {{ $t('Baht') }}</v-flex
        >
      </v-layout>
      <v-layout class="pa-2" v-if="params.match(/presets_fb$/g)">
        <v-flex>{{ $t('Unlock the template') }}</v-flex>
        <v-flex class="text-xs-right">300 {{ $t('Baht') }}</v-flex>
      </v-layout>
      <v-layout class="pa-2">
        <v-flex>{{ $t('Total') }}</v-flex>
        <v-flex class="text-xs-right"
          >{{
            ((params != 'btn_presets_fb' ? zwiz_package.discount : 0) +
              (params.match(/presets_fb$/g) ? 300 : 0))
              | numberFormat
          }}
          {{ $t('Baht') }}</v-flex
        >
      </v-layout>
    </div>

    <v-divider class="mb-3"></v-divider>
    <div class="primary--text">{{ $t('Bank Transfer Info') }}</div>
    {{ errors.first() }}
    <div v-show="!loading">
      <payment-form v-model="input" :params="params" @onSave="saveData('transfer')" :isFlat="true">
        <div slot="footer" class="text-xs-center" slot-scope="scope">
          <div v-show="ptype == 'paypal'">
            <v-flex v-show="type == 'paypal'" xs12 class="text-xs-center">
              <div :ref="params" :id="params" style="margin-top: 15px"></div>
            </v-flex>
          </div>
          <div v-show="ptype == 'transfer'" style="height: 100%">
            <v-btn class dark color="#3C5A99" @click="scope.saveData()" :loading="loading">
              <em class="fab fa-facebook-square mr-2" />
              {{ $t('Continue to purchase in Messenger') }}
            </v-btn>
          </div>
        </div>
      </payment-form>
    </div>
    <template v-if="loading">
      <div style="height: 420px">
        <v-container fill-height grid-list-md text-xs-center>
          <v-layout row wrap align-center>
            <v-flex>
              <scale-loader
                :loading="loading"
                :color="$vuetify.theme.primary"
                height="45px"
                width="7px"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import PaymentForm from '@/components/elements/PaymentForm.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  props: ['params', 'type', 'pack', 'zwiz_package', 'pid'],
  data() {
    return {
      loading: false,
      loading_paypal: true,
      ptype: 'paypal',
      paypal_actions: undefined,
      input: {
        age: null,
        phoneno: '',
        province: '',
        email: '',
        business_type: '',
        suggest: '',
        reason_to_buy: '',
        suggest_other: '',
        locale: '',
        source: 'CMS',
        contact: ''
      },
      input_cache: '',
      options: {
        reason_to_buy: [
          'Real-time Response',
          'Line chatbot',
          'status & Tag',
          'Broadcast (Customize)',
          'Shop service (unlimited)',
          'Import previous users',
          'AI Training',
          'Line notification',
          'Reply to a comment (selected posts)'
        ],
        businesstype: [
          'Accessory',
          'Application & Platform',
          'Automotive',
          'Agriculture',
          'Accommodation',
          'Beauty',
          'Blogger',
          'Construction',
          'Dental Clinic',
          'Education',
          'Electronics',
          'Event',
          'Fashion',
          'Finance & Investment',
          'Food & Beverage',
          'Gadget & IT',
          'Game',
          'Gold',
          'Health',
          'Insurance',
          'Lifestyle',
          'Logistics',
          'Media & Entertainment',
          'Medication',
          'Mom and Kids',
          'Online Marketing',
          'Property',
          'Packaging',
          'Restaurant',
          'Travel',
          'Others'
        ],
        suggest: ['Facebook', 'Google', 'Other']
      }
    }
  },
  components: {
    Multiselect,
    AutoresizeTextarea,
    ScaleLoader,
    PaymentForm
  },
  computed: {
    formErrors() {
      return this.errors.items
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    let vm = this
    this.input_cache = JSON.stringify(this.input)
    this.getInfo()
    if (this.ptype == 'paypal') {
      vm.$nextTick(function () {
        let itemname = vm.params.split('_')
        itemname.splice(0, 1)

        vm.renderPaypalBtn(`#${vm.params}`, itemname.join('_'))
      })
    }
  },
  methods: {
    close() {
      this.$emit('onClose')
    },
    getInfo() {
      var vm = this
      let data = { pageid: vm.selectedBot.pageid, type: vm.ptype, package: vm.pack }
      vm.loading = true

      api.getInfocustomerspremium(data, (error, response) => {
        if (error) console.error(error)

        if (response.data.length) {
          Object.assign(vm.input, response.data[0])
        }
        vm.errors.clear()
        vm.loading = false
      })
    },
    renderPaypalBtn: function (btn_name, itemname) {
      var SERVER = 'https://zwizai.herokuapp.com'
      var vm = this
      // console.log(btn_name,$(btn_name),vm.$refs[btn_name])
      // console.log(vm.$refs[btn_name])
      // var locale = this.currentLang == 'th' ? 'th_TH' : 'en_US'
      var locale = this.currentLang == 'th' ? 'th_TH' : 'gb' ? 'en_US' : 'la_LA'
      if ($(btn_name).get(0)) {
        paypal.Button.render(
          {
            locale: locale,
            env: vm.environment, // Or 'production'
            // Set up the payment:
            // 1. Add a payment callback
            payment: function (data, actions) {
              // 2. Make a request to your server
              return actions.request
                .post(SERVER + '/my-api/create-payment/', {
                  itemname: itemname,
                  pageid: vm.selectedBot.pageid
                })
                .then(function (res) {
                  // 3. Return res.id from the response
                  return res.id
                })
            },
            // Execute the payment:
            // 1. Add an onAuthorize callback
            onAuthorize: function (data, actions) {
              // 2. Make a request to your server
              return actions.request
                .post(SERVER + '/my-api/execute-payment/', {
                  paymentID: data.paymentID,
                  payerID: data.payerID,
                  itemname: itemname,
                  pageid: vm.selectedBot.pageid
                })
                .then(function (res) {
                  // 3. Show the buyer a confirmation message.
                  // alert("payment completed");

                  // console.log(res)
                  vm.$store.dispatch('loading')
                  if (res.status == 'success') {
                    if (vm.selectedBot) {
                      vm.$store.dispatch('updateBotDetail').then(
                        function () {
                          vm.$store.dispatch('loading')
                          vm.$swal
                            .fire({
                              title: vm.$t('Payment successful'),
                              type: 'success',
                              confirmButtonText: vm.$t('Confirm'),
                              cancelButtonText: vm.$t('cancel'),
                              reverseButtons: true,
                              footer: vm.$t(
                                'If you want any help, please contact via E-mail: sales@zwiz.ai'
                              )
                            })
                            .then((result) => {
                              vm.$swal.fire({
                                title: vm.$t('Please wait,we will get back to you shortly'),
                                type: 'info',
                                confirmButtonText: vm.$t('Confirm'),
                                showCancelButton: false,
                                reverseButtons: true,
                                footer: vm.$t(
                                  'If you want any help, please contact via E-mail: sales@zwiz.ai'
                                )
                              })
                            })
                        },
                        function (error) {
                          vm.$store.dispatch('loading')
                          vm.errorMessage = vm.$t(
                            'Cannot update a chatbot. please contact us via Email:'
                          )
                          vm.$swal.fire({
                            title: vm.$t('Payment Unsuccessful'),
                            text: vm.errorMessage,
                            type: 'error',
                            confirmButtonText: vm.$t('Confirm'),
                            cancelButtonText: vm.$t('cancel'),
                            reverseButtons: true,
                            footer: vm.$t(
                              'If you want any help, please contact via E-mail: sales@zwiz.ai'
                            )
                          })
                        }
                      )
                    }
                    // vm.saveData('paypal')
                    // vm.close()
                  } else {
                    vm.errorMessage = res.status
                    vm.$swal.fire({
                      title: vm.$t('Payment Unsuccessful'),
                      text: vm.errorMessage,
                      type: 'error',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true,
                      footer: vm.$t(
                        'If you want any help, please contact via E-mail: sales@zwiz.ai'
                      )
                    })
                    // vm.saveData('paypal')
                    // vm.close()
                  }
                })
            },
            validate: function (actions) {
              vm.paypal_actions = actions
              vm.paypal_actions.disable()
            },
            onClick: function (data, actions) {
              if (vm.paypal_actions) {
                vm.$validator.validate().then((result) => {
                  if (!result) {
                    // do stuff if not valid.
                    vm.paypal_actions.disable()
                    return false
                  }
                  vm.saveData('paypal')
                  vm.paypal_actions.enable()
                })
              }
            }
          },
          btn_name
        )
      }
    },
    saveData(type) {
      let vm = this
      let openMsg
      var options = [
        [{ pid: 8521, qty: 1, option: '3 MONTHS' }],
        [{ pid: 8520, qty: 1, option: '6 MONTHS' }],
        [{ pid: 8519, qty: 1, option: '1 YEAR' }],
        [{ pid: 12233, qty: 1, option: '1 YEAR AND SERVICE' }],
        [{ pid: 31390, qty: 1, option: '3 MONTHS AND TEMPLATE' }],
        [{ pid: 31392, qty: 1, option: '6 MONTHS AND TEMPLATE' }],
        [{ pid: 31402, qty: 1, option: '1 YEAR AND TEMPLATE' }],
        [{ pid: 31403, qty: 1, option: 'TEMPLATE' }]
      ]
      var option = null
      if (vm.pid == 8521) {
        option = options[4]
      } else if (vm.pid == 8520) {
        option = options[5]
      } else if (vm.pid == 8519) {
        option = options[6]
      } else {
        option = options[7]
      }

      openMsg = () => {
        window.location.assign(
          `https://m.me/361231620965547?ref=tempcart_${JSON.stringify(option)}`
        )
      }

      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.loading = true

        vm.input.locale = vm.$store.state.currentLang
        vm.input.type = vm.ptype
        vm.input.facebook_name = vm.$store.state.facebook_name
        vm.input.pagename = vm.selectedBot.pagename
        let data = {
          pageid: vm.$store.state.selectedBot.pageid,
          obj: vm.input,
          package: vm.pack
        }
        api.postInfocustomerspremium(data, (error, response) => {
          if (error) console.error(error)
          vm.loading = false
          if (vm.ptype == 'transfer') {
            vm.close()
            openMsg()
          }
        })
      })
    }
  },
  watch: {
    input: {
      deep: true,
      handler() {
        let vm = this
        if (vm.ptype == 'paypal') {
          vm.$validator.validate().then((result) => {
            if (!result) {
              // do stuff if not valid.
              vm.paypal_actions.disable()
              vm.errors.clear()
              return false
            }
            vm.paypal_actions.enable()
          })
        }
      }
    },
    dialog() {
      let vm = this
      if (vm.dialog == true) {
        let data = { pageid: vm.$store.state.selectedBot.pageid, type: vm.type, package: vm.pack }
        vm.loading = true

        api.getInfocustomerspremium(data, (error, response) => {
          if (error) console.error(error)

          if (response.data.length) {
            Object.assign(vm.input, response.data[0])
          }
          vm.errors.clear()
          vm.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/getstarted/PaypalPayment.vue